import { useCallback, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { WEBVIEW } from '@constants/serviceConstants';
import { setAxiosToken } from '@api/axiosInstance';
import { isWebView } from '@lib/native';

// =================================================================
//                       Native RNListener
// =================================================================
/**
 * Native -> Web
 * 100  : 토큰 정보 수신 및 저장
 * 101  : AI 에이전트 조언 요청
 * */
export default function RNListener({ children }) {
  const navigate = useNavigate();

  /** react native 환경에서만 가능 */
  const listener = useCallback(
    (event) => {
      if (!event) {
        return;
      }
      const { code } = JSON.parse(event.data);
      let { data } = JSON.parse(event.data);
      const { Authorization } = data;

      if (Authorization) {
        setAxiosToken(Authorization);
        data = _.omit(data, ['Authorization']);
      }

      switch (code) {
        case WEBVIEW.RECEIVE_CODE.AUTHORIZATION: // 토큰 정보
          setAxiosToken(data.authorization);
          break;
        case WEBVIEW.RECEIVE_CODE.AI_CHAT: // AI 에이전트 조언
          window.getAiAdvice(data);
          break;
        case WEBVIEW.RECEIVE_CODE.AI_CHAT_TEST: // gpt 테스트
          window.getAiAdviceTest(data);
        default:
          break;
      }
    },
    [navigate]
  );

  useEffect(() => {
    //app 환경일 경우
    if (isWebView()) {
      /** android */
      document.addEventListener('message', listener);
      /** ios */
      window.addEventListener('message', listener);
    }
  }, [listener]);

  return children;
}
